import React, { useRef } from 'react';
import JWPlayer from '@jwplayer/jwplayer-react';

const VideoPlayer = () => {
    const playerRef = useRef(null);

    const playerConfig = {
        playlist: [{
            file: process.env.REACT_APP_JW_STREAM_URL
        }],
        controls: true,
        muted: true,
        autostart: true
    };

    const tryReconnect = (event) => {
        console.log("Stream stopped - refreshing page in 3 seconds");
        setTimeout(() => {
            window.location.reload();
        }, 3000); // 3 second delay before refresh
    };

    const onReady = (player) => {
        playerRef.current = player;
        playerRef.current?.on("error", tryReconnect);
        playerRef?.current?.on("playAttemptFailed", tryReconnect);
    };

    return (
        <div className="player-container">
            <JWPlayer
                library={`https://cdn.jwplayer.com/libraries/${process.env.REACT_APP_JW_KEY}.js`}
                config={playerConfig}
                onReady={onReady}
                onError={tryReconnect}
            />
        </div>
    );
};

export default VideoPlayer;
